// extracted by mini-css-extract-plugin
export default {"icon":"device_bound_icon__UIqZW","bound":"device_bound_bound__WeYrE device_bound_icon__UIqZW"};